import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RangoProveedorComponent } from './rango-proveedor/rango-proveedor.component';
import { FleteCiudadComponent } from './flete-ciudad/flete-ciudad.component';

const routes: Routes = [
  {
    path: '', children: [

      { path: 'definicion_rangos', component: RangoProveedorComponent },
      { path: 'asignacion_flete', component: FleteCiudadComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConfigurationRoutingModule { }
